import fetchLogin from './login';
import fetchMe from './me';
import fetchMeEdit from './meEdit';
import fetchMeGet from './meGet';
import fetchListing from './listing';
import fetchCreate from './create';
import fetchDelete from './delete';
import fetchDetail from './detail';
import fetchEdit from './edit';

const USER_ROLES = {
  ADMIN: 'admin',
  USER: 'user',
};

export {
  fetchLogin,
  fetchMe,
  fetchMeEdit,
  fetchMeGet,
  fetchListing,
  fetchCreate,
  fetchDelete,
  fetchDetail,
  fetchEdit,
  USER_ROLES,
};
